import { isEmpty, isNil } from 'lodash';
import {
  CALIBRATION_MODEL_NAME,
  OPM_CALCULATOR_MODEL_NAME,
  RANGE_SENSITIVITY_MODEL_NAME,
} from 'pages/ValuationsAllocation/common/constants/valuations';
import { VALUATION_SUMMARY_KEY } from 'pages/ValuationsAllocation/common/constants/valuationSummary';
import { Configuration } from 'pages/ValuationsAllocation/hooks';
import { getObjectValue } from 'utilities';

const filterApproaches = (config: Configuration) => {
  const { isEquityAllocation, isWeightedShareValues, name, spreadsheets } = getObjectValue(config);

  return (
    name !== VALUATION_SUMMARY_KEY && // Exclude Valuation Summary
    name !== CALIBRATION_MODEL_NAME &&
    name !== RANGE_SENSITIVITY_MODEL_NAME &&
    name !== OPM_CALCULATOR_MODEL_NAME &&
    !isEmpty(spreadsheets) && // Exclude empty Configurations
    isNil(isEquityAllocation) && // Exclude Equity Allocation
    isNil(isWeightedShareValues) // Exclude Weighted Share Values
  );
};

export default filterApproaches;
